export default __webpack_public_path__ + "asset/img/no-data~bc02ff60.png";